
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"react-hooks-workshop"}}>{`React Hooks Workshop`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"ressources"}}>{`Ressources`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="a" components={components} parentName="li" props={{"href":"https://github.com/smooth-code/react-hooks-workshop"}}>{`Exercices sur GitHub`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="a" components={components} parentName="li" props={{"href":"https://slides.react-hooks.smooth-code.com/"}}>{`Support de cours`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"démarrer-les-exercices"}}>{`Démarrer les exercices`}</MDXTag>
<MDXTag name="p" components={components}>{`Ouvrez un terminal, placez vous dans le dossier choisi et tapez les commandes suivantes :`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{}}>{`npm install --global smooth-code-cli
smooth-code init react-hooks-workshop
cd react-hooks-workshop
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"naviguer-dans-les-exercices"}}>{`Naviguer dans les exercices`}</MDXTag>
<MDXTag name="p" components={components}>{`L'outil `}<MDXTag name="inlineCode" components={components} parentName="p">{`smooth-code-cli`}</MDXTag>{` que vous venez d'installer vous permet de naviguer dans les exercices et d'afficher la réponse sur GitHub, elle est pas belle la vie !`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{}}>{`Usage: smooth-code [command]

Commands:

  start <exercise>      Go to the beginning of an exercise
  end <exercise>        Go to the end of an exercise
  solution <exercise>   Get the solution of an exercise
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  